export const ERR_API_CALL_TRANSCRIPTS_NOT_READY =
  'ERR_API_CALL_TRANSCRIPTS_NOT_READY';
